<div class="main">
    <div class="main-context">
        <div class="main-context-heading">
            <fui-page-header-heading [description]="description | translate"
                                     [title]="title | translate"></fui-page-header-heading>
        </div>
        @if (pageHeaderNav) {
            <div class="main-context-nav">
                <ng-content select="fui-page-header-nav"></ng-content>
            </div>
        }
        <div class="main-context-toggle">
            @if (hasToggle) {
                <fui-section-toggle [toggled]="toggled" (toggled$)="toggle($event)"></fui-section-toggle>
            }
        </div>
    </div>
    @if (toggled) {
        <div class="main-content">
            <ng-content></ng-content>
        </div>
    }
</div>
@if (breadcrumbs) {
    <div class="breadcrumbs">
        <ng-content select="fui-breadcrumbs"></ng-content>
    </div>
}
